<template>
  <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">{{ $t('Statement-of-Account-by-Reference') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">
              </v-text-field>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row wrap>

              <v-flex pa-1 v-show="EkstreHesap.TlDoviz ==false" xs12 sm6 md6>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                 {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentDebtTotal | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ currentCreditTotal | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-"> {{ $t('Current-Period') }} : {{cariBakiye | bakiyekontrolsimgeli}} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex pa-1 v-show="EkstreHesap.TlDoviz==false" xs12 sm6 md6>
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ debtTotal | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ creditTotal | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-">{{ $t('General-Balance') }}  : {{genelBakiye | bakiyekontrolsimgeli}} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 v-show="EkstreHesap.TlDoviz" sm12 md12>
                <v-flex xs12 sm12 md12>
                  <v-card flat="" class="black--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex pb-2 xs12 sm12 md12>
                            <v-layout align-center="" justify-start="" fill-height="">
                              <span class="subheading black--text font-weight-"> {{ $t('TRY-Foreign-Currency-General-Totals') }} 
                              </span>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-layout row wrap>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-"> {{ $t('Currency-Type') }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Current-Payable') }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Current-Receivable') }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Total-Debit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Total-Credit') }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-">
                                      {{ $t('Total-Balance') }}
                                    </span>
                                  </v-layout>
                                </v-flex>




                              </v-layout>
                              <v-divider light></v-divider>

                              <v-layout row wrap v-for="item in tldovizToplamlar" :key="item.id">
                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="body-2 font-weight-thin">
                                      {{item.Doviz.DovizKod}} </span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-2 font-weight-thin">
                                      {{item.DonemBorc | moneyformat}}</span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-2n font-weight-thin">
                                      {{item.DonemAlacak | moneyformat}}</span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-2 font-weight-thin">
                                      {{item.ToplamBorc | moneyformat}}</span>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-2 font-weight-thin">
                                      {{item.ToplamAlacak | moneyformat}}</span>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="body-2 font-weight-thin">
                                      {{item | bakiyebak}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs12 sm12 md12>
                                  <v-divider light></v-divider>
                                </v-flex>
                              </v-layout>

                            </v-card>
                          </v-flex>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


              </v-flex>



            </v-layout>
          </v-container>


          <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">
            <v-card flat color="grey lighten-5">

              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>

                <v-flex xs12 sm12 md12>
                  <v-card flat="" class="white--text">
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>

                         <cariaracomp v-bind:etiket="$t('Current-Account')" v-bind:value="EkstreHesap.Cari.Kod" 
                           v-model="EkstreHesap.Cari.Kod"></cariaracomp>

                          <v-autocomplete hide-details clearable :items="evraktipi" v-model="secilenevraklar"
                            :label="$t('Document-Type')" multiple item-text="Title" item-value="Evrakkod">
                            <template slot="selection" slot-scope="{ item, index }">
                              <v-chip v-if="index === 0">
                                <h4> <span>{{ item.Evrakkod }}</span> </h4>
                              </v-chip>
                              <span v-if="index === 1" class="grey--text caption">(+{{
                                  EkstreHesap.Evraklar.length - 1 }} {{ $t('other-record') }})</span>
                            </template>
                          </v-autocomplete>

                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>

                </v-flex>



                <v-flex pa-2 xs12 sm12 md12>
                  <v-layout justify-space-between column>
                    <v-checkbox hide-details="" v-model="EkstreHesap.TlDoviz" :label= "this.getparabirimi() + ' ' + '+' + ' ' +  $t('Currency')"></v-checkbox>
                    <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>
                  </v-layout>
                </v-flex>

              </v-card-text>

              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-container fluid="">
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"
                      v-model="date"></tarihcomp>


                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"
                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"
                      v-model="date2"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm12 md3>
                  
                    <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="EkstreHesap.Referans.Kod" >
                              </referansmerkezicomp>
                  </v-flex>

                  <v-flex>
                    <v-layout>
                      <div v-if="load1">
                        <v-btn color="info" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>
                      </div>


                  <v-badge color="white"  :overlap="true">
                      <template v-slot:badge>
                          <v-icon v-if="filtrevarmi" large color="green">
                            check_circle_outline                                   
                          </v-icon>
                      </template>

                      <v-btn small="" @mouseenter="tooltip = true"
                          @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                          color="info" fab dark>
                          <v-icon>filter_list</v-icon>
                      </v-btn>
                       <v-tooltip bottom="" :activator="el" v-model="tooltip">
                      <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>

                   </v-badge>


                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>

            <v-layout row="" wrap>
              <v-flex xs12 sm12>
                <v-card flat>
                  <v-card-title>
                    <v-spacer></v-spacer>

                  </v-card-title>
                  <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="items"
                    :search="search3">
                    <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                      <td class="text-xs-left">{{ props.item.Cari.Kod }}</td>
                      <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                      <td class="text-xs-left">{{ props.item.Evrakno}}</td>
                      <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                      <td class="text-xs-left">{{ props.item.Vade | dateformat }}</td>
                      <td class="text-xs-right">{{ props.item.Borc | moneyformat}}</td>
                      <td class="text-xs-right">{{ props.item.Alacak | moneyformat}}</td>
                      <td v-show="EkstreHesap.TlDoviz" class="text-xs-center">{{ props.item.Doviz.DovizKod}}</td>
                      <td v-show="EkstreHesap.TlDoviz" class="text-xs-right">{{ props.item.DvzTutar | moneyformat }}
                      </td>
                      <td v-show="EkstreHesap.TlDoviz" class="text-xs-right">{{ props.item.Kur | currencyformat}}</td>
                    </template>
                    <v-alert slot="no-results" :value="true" color="error" icon="warning">
                       {{ $t('No-records-searched-for', { value: search3}) }}
                    </v-alert>
                  </v-data-table>
                </v-card>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                  :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"
                  v-model="snackbar">
                  {{ text }}
                  <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                </v-snackbar>
              </v-flex>

            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"

  export default {
    data() {
      return {
        PB:'TRY',
         sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi:false,
        tldovizToplamlar: [],
        cariBakiye: 0,
        genelBakiye: 0,
        search: '',

        headers: [],
        headerstl: [{
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Reference'),
            value: 'Cari.Kod'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade'
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            align: 'right'
          },
          {
            text: this.$t('Credit'),
            value: 'Alacak',
            align: 'right'
          }
        ],
        headersdoviz: [{
            text: this.$t('Date'),
            value: 'Tarih'
          },
          {
            text: this.$t('Reference'),
            value: 'Cari.Kod'
          },
          {
            text: this.$t('Document-Type'),
            value: 'Evrak.Evrakkkod'
          },
          {
            text: this.$t('Document-No'),
            value: 'Evrakno'
          },
          {
            text: this.$t('Description'),
            value: 'Aciklama'
          },
          {
            text: this.$t('Maturity-Date'),
            value: 'Vade'
          },
          {
            text: this.$t('Debit'),
            value: 'Borc',
            align: 'right'
          },
          {
            text: this.$t('Credit'),
            value: 'Alacak',
            align: 'right'
          },
          {
            text: this.$t('Currency-Type'),
            value: 'Doviz.DovizKod',
          },
          {
            text: this.$t('Currency-Amount'),
            value: 'DvzTutar',
            align: 'right'
          },
          {
            text: this.$t('Exchange-Rate-v2'),
            value: 'Kur',
            align: 'right'
          }
        ],


        EkstreHesap: {
          Referans: {
            Kod: '',
          },
          BaslangicTarih: '',
          BitisTarih: '',
          Evraklar: [],
          Cari: {
            Kod: ''
          },
          SirketKodu: '',
          TlDoviz: false,
        },

        currentDebtTotal: 0,
        currentCreditTotal: 0,
        debtTotal: 0,
        creditTotal: 0,
        StartDate: null,
        EndDate: null,
        statecari: [],
        Referans: [],
        searchcari: '',
        valid: true,

        renk1: 'info',
        dialogfiltre: false,
        evraktipi: [],
        anahesap: [],
        tumsirketler: '',
        secilenevraklar: [{
          Evrakkod: ''
        }],


        dictionary: {
          custom: {
            referanskod: {
              required: () => this.$t('Please-select')
            },
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },



        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        progress: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text: '',
        tooltip: false,
        el: null,
      }
    },
     beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      cariaracomp,
      referansmerkezicomp
    },
    watch: {
      'EkstreHesap.TlDoviz': function (t) {
        if (t) {
          this.headers = this.headersdoviz
        } else {
          this.headers = this.headerstl
        }
      }
    },
    mounted() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.el = this.$refs.fab.$el


      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }

    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      currencyformat: function (m) {
        return helpers.currencyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      bakiyekontrolsimgeli: function (m) {
        return helpers.bakiyekontrolsimgeli(m);
      },
      bakiyebak: function (m) {

        var t = m.ToplamBorc - m.ToplamAlacak
        return helpers.bakiyekontrol(t);
      }

    },
    methods: {
          getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,

      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params3 = {
      CompanyCode: credentials.SirketKodu
    }




    this.$http.post(auth.API_URL + 'api/doctype/List', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
    })

  }

  function filtrekayit() {
    this.filtrevarmi=true
    this.getList()
    this.dialogfiltre = false
  }

  function filtreiptal() {
        this.filtrevarmi=false

    this.renk1 = 'info'
    this.dialogfiltre = false
    this.secilenevraklar = []
    this.tumsirketler = false
    this.EkstreHesap.TlDoviz = false
    this.EkstreHesap.Cari.Kod = null
  }



  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        this.progress = true
        this.currentDebtTotal = 0
        this.currentCreditTotal = 0
        this.debtTotal = 0
        this.creditTotal = 0
        this.tldovizToplamlar = [];

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.load = true
        this.load1 = false
        var Evraklar1 = []

        if (this.secilenevraklar.length > 0) {
          Object.keys(this.secilenevraklar).forEach(key => {
            var evrak = {
              Evrakkod: this.secilenevraklar[key]
            }
            Evraklar1.push(evrak)
          });

        }

        this.EkstreHesap.Evraklar = Evraklar1
        //this.EkstreHesap.Evraklar.Evrakkod = this.secilenevraklar


        if (this.tumsirketler === true) {
          this.EkstreHesap.SirketKodu = 0
        } else {
          this.EkstreHesap.SirketKodu = credentials.SirketKodu
        }

        this.EkstreHesap.BaslangicTarih = this.date
        this.EkstreHesap.BitisTarih = this.date2

        var params1 = this.EkstreHesap


        this.load1 = false

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithReference', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body[0].EkstreList

          if (this.EkstreHesap.TlDoviz) {
            this.tldovizToplamlar = response.body[0].Toplamlar
          }

          this.currentCreditTotal = response.body[0].Toplamlar[0].DonemAlacak
          this.currentDebtTotal = response.body[0].Toplamlar[0].DonemBorc
          this.cariBakiye = response.body[0].Toplamlar[0].DonemBorc - response.body[0].Toplamlar[0].DonemAlacak
          this.debtTotal = response.body[0].Toplamlar[0].ToplamBorc
          this.creditTotal = response.body[0].Toplamlar[0].ToplamAlacak
          this.genelBakiye = response.body[0].Toplamlar[0].ToplamBorc - response.body[0].Toplamlar[0].ToplamAlacak



          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }


  function getListHtml() {

    this.$validator.validateAll().then((result) => {
      this.progress = true
      this.currentDebtTotal = 0
      this.currentCreditTotal = 0
      this.debtTotal = 0
      this.creditTotal = 0

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      this.load = true
      this.load1 = false
      var Evraklar1 = []

      if (this.secilenevraklar.length > 0) {
        Object.keys(this.secilenevraklar).forEach(key => {
          var evrak = {
            Evrakkod: this.secilenevraklar[key]
          }
          Evraklar1.push(evrak)
        });

      }

      this.EkstreHesap.Evraklar = Evraklar1

      if (this.date == null) {
        this.date = getDateNow()
      }

      if (this.date2 == null) {
        this.date2 = getDateNow()
      }


      if (this.tumsirketler === true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }

      this.EkstreHesap.BaslangicTarih = this.date
      this.EkstreHesap.BitisTarih = this.date2

      var params1 = this.EkstreHesap


      this.load1 = false

      this.$http
        .post(auth.API_URL + "api/Abstract/ListWithReferenceHtml", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {

          if (lang=='en')
          {
            
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> REFERANS EKSTRESİ </title>','<title> EXTRACT BY REFERANCES </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>REFERANS EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>EXTRACT BY REFERANCES</font>")

            
             response.bodyText=bodyhtml;
             
          }
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('ReferenceExtract') + ".html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    })
  }

  function getListExcel() {

    this.$validator.validateAll().then((result) => {

      this.progress = true
      this.currentDebtTotal = 0
      this.currentCreditTotal = 0
      this.debtTotal = 0
      this.creditTotal = 0

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      this.load = true
      this.load1 = false
      var Evraklar1 = []

      if (this.secilenevraklar.length > 0) {
        Object.keys(this.secilenevraklar).forEach(key => {
          var evrak = {
            Evrakkod: this.secilenevraklar[key]
          }
          Evraklar1.push(evrak)
        });

      }

      this.EkstreHesap.Evraklar = Evraklar1
      //this.EkstreHesap.Evraklar.Evrakkod = this.secilenevraklar

      if (this.date == null) {
        this.date = getDateNow()
      }

      if (this.date2 == null) {
        this.date2 = getDateNow()
      }


      if (this.tumsirketler === true) {
        this.EkstreHesap.SirketKodu = 0
      } else {
        this.EkstreHesap.SirketKodu = credentials.SirketKodu
      }

      this.EkstreHesap.BaslangicTarih = this.date
      this.EkstreHesap.BitisTarih = this.date2

      var params1 = this.EkstreHesap


      this.load1 = false

      this.$http
        .post(auth.API_URL + "api/Abstract/ListWithReferenceExcel", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = this.$t('ReferenceExtract') + ".xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    })
  }

  function beforeMount() {
this.headers=this.headerstl

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }


    // this.$http.post(auth.API_URL + 'api/Reference/List', params, {
    //   headers: {
    //     'Authorization': 'Bearer ' + auth.getAuthHeader()
    //   }
    // }).then((response) => {
    //   this.Referans = response.body
    // }, (response) => {
    //       if (response.status === 0) {
    //         this.text = 'Service Unavailable'
    //         this.snackbar = true
    //       } else {
    //         this.text = 'Service Unavailable'
    //         this.snackbar = true
    //       }
    // })

    this.$http.post(auth.API_URL + 'api/doctype/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.evraktipi = response.body

    }, (response) => {
     if (response.status === 0) {
       this.text = 'Service Unavailable'
       this.snackbar = true
     } else {
       this.text = 'Service Unavailable'
       this.snackbar = true
     }
    })
    this.secilenevraklar = []
    this.EkstreHesap.Referans.Kod = null
  }
</script>
<style>
</style>